import React from 'react';
import Box from '@quintoandar/cozy-core/Box';
import { Loading } from 'components/Loading';

export const LoadingPage = () => (
  <Box mt={4} height={200}>
    <Loading isVisible centered />
  </Box>
);
